import { render, staticRenderFns } from "./FinalDispatchRequestActions.vue?vue&type=template&id=2400ffe1&scoped=true&"
import script from "./FinalDispatchRequestActions.vue?vue&type=script&lang=js&"
export * from "./FinalDispatchRequestActions.vue?vue&type=script&lang=js&"
import style0 from "./FinalDispatchRequestActions.vue?vue&type=style&index=0&id=2400ffe1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2400ffe1",
  null
  
)

export default component.exports